<div class="label">{{ label() }}</div>
<div class="options">
  @for (option of options(); track option.id) {
    <procure-input-check [control]="control().controls[option.id]">
      {{ option.name ?? option.code ?? option.id }}
    </procure-input-check>
  }
</div>
